import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";

export const APP_URL = process.env.REACT_APP_APP_API_URL;
export const TOKEN_KEY = "cs_token";

export const api = axios.create({ baseURL: `${APP_URL}/api` });
api.interceptors.request.use((c) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const useApi = (path, opts = {}) =>
  useQuery({
    queryKey: [path],
    queryFn: () => api.get(path).then((r) => r.data),
    enabled: !!path && (opts.enabled ?? true),
    retry: false,
    ...(opts.refetchInterval ? { refetchInterval: opts.refetchInterval } : {}),
  });

export const media = (u) => (!u ? null : u.startsWith("/") ? `${APP_URL}${u}` : u);
export const shareUrl = (eventId) => `${process.env.REACT_APP_PUBLIC_SITE_URL}/e/${eventId}`;
export const copyShareLink = async (eventId) => {
  const url = shareUrl(eventId);
  try { await navigator.clipboard.writeText(url); toast.success("Link copied", { description: url }); }
  catch { toast.message("Share this link", { description: url }); }
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return e?.message || "Something went wrong";
};

export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd);
  return data.url;
};

const FALLBACKS = [
  "https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=900&q=80",
  "https://images.unsplash.com/photo-1595351298020-038700609878?w=900&q=80",
  "https://images.unsplash.com/photo-1547573854-74d2a71d0826?w=900&q=80",
  "https://images.unsplash.com/photo-1673339065001-a30d6c343cdd?w=900&q=80",
];
export const eventImage = (e) => {
  const own = media(e?.flyer || e?.location_image);
  if (own) return own;
  const s = String(e?.id || "");
  const h = [...s].reduce((a, c) => a + c.charCodeAt(0), 0);
  return FALLBACKS[h % FALLBACKS.length];
};

export const money = (p) => (p ? `$${Number(p).toFixed(Number(p) % 1 ? 2 : 0)}` : "Free");
